import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import ContentArea from '@episerver/spa-core/Components/ContentArea';

import { getImageProps } from 'app/utilities/ImageProps';
import download from '../../icons/download.svg';
import Config from '../../../../../Config';

function ProductDescription({detailsProdact, epiData, context, openInstallationGuide}) {
    
    if(detailsProdact === null) return null;

    const imageProdact = getImageProps(detailsProdact.imageProduct, context);
    const nameProduct = detailsProdact.nameProduct?.value;
    const nameModelProdact = detailsProdact.nameModelProdact?.value;
    const displayName = nameModelProdact && nameModelProdact.trim() !== '' ? nameModelProdact : nameProduct;

    
    useEffect(() => {
        // Image-background photo on mobile/desktop
        document.documentElement.style.setProperty('--support-topics-bg-web', `url(${Config.epiBaseUrl + epiData.imageTitle.value?.url })`);
        document.documentElement.style.setProperty('--support-topics-bg-mobile', `url(${Config.epiBaseUrl + epiData.imageTitleMobile.value?.url})`);
    
    }, []);


    return (
        <div className='wrapper-product-page' >
            <div className='image-background'>
                <div className='layout'>
                    <h2 clssName='detail-page'>{displayName}</h2>
                    {imageProdact.src && <Image src={imageProdact.src} alt='image' />}
                </div>
                <div className='wrapper-product-description'>
                {detailsProdact?.detailsList?.expandedValue?.map((item, index) => {
                    return (
                    <div key={index} className="item">
                        {item.icon?.value?.url  && <Image src={Config.epiBaseUrl + item.icon.value.url} alt="icon" />}
                        {item?.text.value && <h2>{item?.text.value}</h2>} 
                    </div>
                    );
                })}
                {detailsProdact.installationGuide.value &&
                    <button className='link-wrapper' onClick={()=>openInstallationGuide(detailsProdact)}>
                        <div>מדריך התקנה</div>
                        <Image src={download} alt='icon' />
                    </button>
                }
            </div>
            </div>
         
        </div>

    );
}

const mapStateToProps = (state) => ({
    epiData: state.equipmentListPage.epiData

});

export default connect(mapStateToProps)(ProductDescription);
